module.exports = __webpack_public_path__ + "img/collect-bg.29489c18.png";